import React from "react";
import LoadingState from "./LoadingState";

export const Loading = () => {
  return <LoadingState message="Authenticatie wordt geladen..." variant="inline" />;
};
